import { styled } from '@material-ui/styles';
import React, { CSSProperties } from 'react';
import { I18n } from '../../../../Locales/I18nService';
import { StringKey } from '../../../../Locales/fr';
import { Assets } from '../../../assets/Assets';
import { StyledComponentProps } from 'Web/Components/Widgets/WithStyledComponent';
import { NunitoSansBoldTitle } from 'Web/Components/Widgets/Typographies';
import { HStack } from 'Web/Components/Widgets/Stack';

export enum TagType {
    ToDo = 'ToDo',
    Done = 'Done',
    Error = 'Error',
}
type TagLabelProps = { type?: TagType; style?: CSSProperties };

export const TagLabel = ({ type = TagType.ToDo, style, ...scProps }: StyledComponentProps<TagLabelProps>) => {
    const tagStyles = useTagStyle(type);
    return (
        <Container data-type-tag={type} {...scProps} style={{ ...tagStyles, ...style }}>
            {type === TagType.Error && <Assets.ErrorIcon style={{ marginRight: 4 }} />}
            <Text>{I18n.get(`TagType_${type}` as StringKey)}</Text>
        </Container>
    );
};

export const TagLabelStyles = {
    ToDoStyle: { background: '#E5A033', color: '#000000' },
    DoneStyle: { background: '#46DBA9', color: '#000000' },
    ErrorStyle: { background: '#ff453a19', color: '#FF453A' },
};

const useTagStyle = (type: TagType) => {
    switch (type) {
        case TagType.ToDo:
            return TagLabelStyles.ToDoStyle;
        case TagType.Done:
            return TagLabelStyles.DoneStyle;
        case TagType.Error:
            return TagLabelStyles.ErrorStyle;
        default:
            return {};
    }
};

const Container = styled(HStack)({
    height: 21,
    minWidth: 80,
    fontSize: 9,
    lineHeight: '12px',
    justifyContent: 'center',
});

const Text = styled(NunitoSansBoldTitle)({ textTransform: 'uppercase', paddingTop: 1 });
